import { toast } from 'react-toastify';

export const fetcher = async <T>(
  data: T,
  url: string,
  fetchWithAuth: (url: string, init: RequestInit) => Promise<Response>,
) => {
  const init: RequestInit = {
    body: JSON.stringify(data),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetchWithAuth(url, init);
  if (response.status > 499 || !response.ok) {
    toast.error(`Applicatiefout ${response.status}: ${response.statusText}`);
    return { werklijnen: null };
  }
  return response.json();
};
